import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { GroupLinksDiv } from './styled'

import GroupLink from './GroupLink'
import GroupContactUs from './GroupContactUs'
import GroupNamContact from './GroupNamContact'
import isBrazil from '../../../../../utils/isBrazil'

const GroupLinks = () => {
  const data = useStaticQuery(graphql`
    query {
      wordpressGeneoneThemeFooter {
        sidebars {
          name
          widgets {
            type
            value {
              rendered
              items {
                title
                url
                object_id
              }
              name
            }
          }
        }
      }
    }
  `)

  const {
    wordpressGeneoneThemeFooter: { sidebars },
  } = data
  const isBr = isBrazil()
  const NAMES_SIDEBAR = {
    NAM: 'NAM',
    AREA_MEDICA: 'Área Médica',
    CONTATO: 'Contato'
  }

  function findWidgetNam() {
    return sidebars.find(function (side) {
      return side.name === NAMES_SIDEBAR.NAM
    })
  }

  return (
    <GroupLinksDiv isBr={isBr}>
      {sidebars.map((sidebar, index) => {
        if (sidebar.widgets === null) {
          return null
        }

        if (sidebar.name === NAMES_SIDEBAR.NAM) return null

        if (sidebar.name === NAMES_SIDEBAR.AREA_MEDICA && isBr) {
          const items = [sidebar]
          const nam = findWidgetNam()
          if (nam) items.push(nam)

          return (
            <div>
              {items.map(item => {
                if (item.widgets === null) return null

                if (item.name === NAMES_SIDEBAR.NAM) {
                  return <GroupNamContact data={item} key={index} />
                } else {
                  return item.widgets.map(widget => {
                    return (
                      <GroupLink
                        key={`footer_${widget.value.name}_${Math.random()}_${index}`}
                        textHeader={widget.value.name || ''}
                        links={widget.value.items || []}
                      />
                    )
                  })
                }
              })}
            </div>
          )
        }

        if (sidebar.name === NAMES_SIDEBAR.CONTATO) {
          if (sidebar.widgets.length === 1) return null
          return <GroupContactUs data={sidebar} key={index} />
        }

        return sidebar.widgets.map(widget => { 
          return (
            <GroupLink
              key={`footerContact_${widget.value.name}_${Math.random()}_${index}`}
              textHeader={widget.value.name || ''}
              links={widget.value.items || []}
            />
          )
        })
      })}
    </GroupLinksDiv>
  )
}

export default GroupLinks
